import Vue from 'vue'

let rm = {
    data: {
        log: false,
    },

    log(a){
        if(this.data.log)
        console.log(a)
    },

    getMeta(that){
        let route = that.$route.meta

        if(route && route.length){
          this.log('Set to default')
          return route
        }

        let first = that.$router.options.routes[0].meta

        this.log('Set falback first route', first)
        return first
    }
}


Vue.prototype.$rm = rm

export default rm
